import { ref } from "vue"
import { defineStore } from "pinia"
import { Preferences } from "@capacitor/preferences"

export const useTokenStore = defineStore("token", () => {
	const accessToken = ref(null)
	const refreshToken = ref(null)

	async function setTokens(access, refresh) {
		accessToken.value = access
		refreshToken.value = refresh
		// if (localStorage) {
		// 	localStorage.setItem("gv-jwt", access)
		// 	localStorage.setItem("gv-refresh", refresh)
		// }
		await Preferences.set({
			key: "gv-jwt",
			value: access,
		})

		await Preferences.set({
			key: "gv-refresh",
			value: refresh,
		})
	}

	async function clearTokens() {
		accessToken.value = null
		refreshToken.value = null
		// if (localStorage) {
		// 	localStorage.removeItem("gv-jwt")
		// 	localStorage.removeItem("gv-refresh")
		// }
		await Preferences.remove({
			key: "gv-jwt",
		})

		await Preferences.remove({
			key: "gv-refresh",
		})
	}

	async function loadTokens() {
		// if (localStorage) {
		// 	accessToken.value = localStorage.getItem("gv-jwt")
		// 	refreshToken.value = localStorage.getItem("gv-refresh")
		// }
		const jwt = await Preferences.get({ key: "gv-jwt" })
		const refresh = await Preferences.get({ key: "gv-refresh" })

		accessToken.value = jwt.value
		refreshToken.value = refresh.value
	}

	function hasToken() {
		return accessToken.value ? true : false
	}

	function getAccessToken() {
		return accessToken.value
	}

	function getRefreshToken() {
		return refreshToken.value
	}

	function getRole() {
		if (!accessToken.value) return null
		const payload = JSON.parse(atob(accessToken.value.split(".")[1]))
		return payload.role
	}

	function getId() {
		if (!accessToken.value) return null
		const payload = JSON.parse(atob(accessToken.value.split(".")[1]))
		return payload.id
	}

	function isTokenExpired(token) {
		if (!token) return true
		try {
			const payload = JSON.parse(atob(token.split(".")[1]))
			return payload.exp * 1000 < Date.now()
		} catch {
			return true
		}
	}

	function isAccessTokenExpired() {
		return isTokenExpired(accessToken.value)
	}

	function isRefreshTokenExpired() {
		return isTokenExpired(refreshToken.value)
	}

	return {
		accessToken,
		refreshToken,
		hasToken,
		setTokens,
		clearTokens,
		loadTokens,
		getAccessToken,
		getRefreshToken,
		getRole,
		getId,
		isAccessTokenExpired,
		isRefreshTokenExpired,
	}
})
